import { getCorrectBearerJwtForUrl } from 'components/accessControl/getCorrectBearerJwtForUrl';
import { v4 as uuidv4 } from 'uuid';

export default function getServerRequestHeader(url: string): Record<string, string> {
  return {
    Authorization: `Bearer ${getCorrectBearerJwtForUrl(url ?? '')}`,
    'spruce-request-id': uuidv4(),
  };
}
